import { get } from "lodash";
import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Button } from "semantic-ui-react";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import SegmentMessage from "../forms/messages/SegmentMessage.jsx";
import FormikSemanticInput from "../forms/formik/FormikSemanticInput.jsx";

import {
  selectLatestErrorMessage,
  selectLatestViolationErrors
} from "../../state/reducers/api/apiSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class LoginForm extends PureComponent {
  static propTypes = {
    showMessages: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isError: PropTypes.number,
    isFetching: PropTypes.bool,
    violationErrors: PropTypes.object,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    showMessages: false,
    isFetching: false
  };

  constructor(props) {
    super(props);

    this.initialValues = {
      username: "",
      password: ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = function () {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      username: Schemas.requiredString("Username", messages, true),
      password: Schemas.requiredString("Password", messages, true)
    });
  };

  // -- HANDLERS -- //

  // triggered whenever the submit button is clicked
  onSubmit = () => {
    this.setState({ showMessages: true });
  };

  // only triggered whenever the submit button is clicked and the form is valid
  onFormikSubmit = (values, actions) => {
    this.props.onSubmit(values);
  };

  // -- RENDER -- //

  renderErrorMessage = () => {
    const { authError, errorMessage, copy } = this.props;

    const copyKey = `sentry.login_error.${authError}`;

    const title = copy(`${copyKey}.title`) || get(errorMessage, "title", "");
    const message =
      copy(`${copyKey}.message`) || get(errorMessage, "message", "");
    const actionLabel =
      copy(`${copyKey}.action.label`) ||
      get(errorMessage, "action.label", undefined);
    const actionURL =
      copy(`${copyKey}.action.url`) ||
      get(errorMessage, "action.url", undefined);

    return (
      <SegmentMessage
        title={title}
        message={message}
        actionLabel={actionLabel}
        actionURL={actionURL}
        negative={true}
      />
    );
  };

  render() {
    const { isFetching, authError, violationErrors, copy } = this.props;

    return (
      <Fragment>
        {!isFetching && authError && this.renderErrorMessage()}
        <Formik
          initialValues={this.initialValues} // required by semantic-ui react
          validateOnMount={true}
          validationSchema={this.validationSchema()}
          onSubmit={this.onFormikSubmit}
        >
          {() => {
            return (
              <Segment padded textAlign="left">
                <Form className="ui large form">
                  <Field
                    name="username"
                    placeholder={copy(`sentry.login.username_placeholder`)}
                    required={true}
                    fluid
                    disabled={isFetching}
                    apiErrors={violationErrors}
                    component={FormikSemanticInput}
                  />

                  <Field
                    name="password"
                    placeholder={copy(`sentry.login.password_placeholder`)}
                    required={true}
                    type="password"
                    fluid
                    disabled={isFetching}
                    apiErrors={violationErrors}
                    component={FormikSemanticInput}
                  />

                  <Button
                    primary
                    fluid
                    loading={isFetching}
                    size="large"
                    type="submit"
                    onClick={this.onSubmit}
                  >
                    {copy("sentry.login.login_cta")}
                  </Button>
                </Form>
              </Segment>
            );
          }}
        </Formik>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.authentication.isFetching,
  authError: state.authentication.authenticationError,
  errorMessage: selectLatestErrorMessage(state),
  violationErrors: selectLatestViolationErrors(state),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(LoginForm);
